import React, { useEffect } from 'react';
import './StepStyles.scss';

interface I9CompletionStepProps {
  employeeId?: string;
  data?: any;
  onDataChange: (data: any) => void;
  onComplete: (isComplete: boolean) => void;
}

const I9CompletionStep: React.FC<I9CompletionStepProps> = ({
  employeeId,
  data,
  onDataChange,
  onComplete,
}) => {
  // Automatically mark as complete when visited since feature is coming soon
  useEffect(() => {
    onComplete(true);
  }, [onComplete]);

  return (
    <div className="wizard-step">
      <div className="step-header">
        <h4>I-9 Completion</h4>
        <p>Complete I-9 verification form</p>
      </div>

      <div className="coming-soon-container">
        <div className="coming-soon-icon">
          <i className="bx bx-file-blank"></i>
        </div>
        <h3 className="coming-soon-title">Coming Soon</h3>
        <p className="coming-soon-message">
          I-9 verification functionality is currently under development.
          This feature will allow you to complete and track I-9 forms
          for new employees in compliance with federal requirements.
        </p>
      </div>
    </div>
  );
};

export default I9CompletionStep;
